import { GuestUserQuery } from '@prophecy/queries/context/mixpanel/query';

import { makeGraphQlCallWithoutShareTokens } from '../../data/util';

export const getGuestUserData = async (guestUserId: string, _enabled?: boolean) => {
  const resp = await makeGraphQlCallWithoutShareTokens(GuestUserQuery, { uid: guestUserId as string });
  return resp?.User ?? {};
};
